import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  // {
  //   path: '/properties-for-sale',
  //   name: 'Properties For Sale',
  //   component: () => import('../views/PropertiesForSale.vue'),
  // },
  // {
  //   path: '/open-homes',
  //   name: 'Open Homes',
  //   component: () => import('../views/InspectionTimes.vue'),
  // },
  // {
  //   path: '/request-appraisal',
  //   name: 'Request Appraisal',
  //   component: () => import('../views/LeaseAppraisal.vue'),
  // },
  // {
  //   path: '/recent-sales',
  //   name: 'Recent Sales',
  //   component: () => import('../views/PropertiesSold.vue'),
  // },
  // {
  //   path: '/properties-for-rent',
  //   name: 'Properties For Rent',
  //   component: () => import('../views/PropertiesForRent.vue'),
  // },
  // {
  //   path: '/tenant-resources',
  //   name: 'Tenant Resources',
  //   component: () => import('../views/Resources.vue'),
  // },
  // {
  //   path: '/maintenance-request',
  //   name: 'Maintenance Request',
  //   component: () => import('../views/MaintenanceRequest.vue'),
  // },
  // {
  //   path: '/vacate-notice',
  //   name: 'Vacate Notice',
  //   component: () => import('../views/Form13.vue'),
  // },
  // {
  //   path: '/lease-appraisal',
  //   name: 'Lease Appraisal',
  //   component: () => import('../views/LeaseAppraisal.vue'),
  // },
  // {
  //   path: '/leased',
  //   name: 'Recently Leased',
  //   component: () => import('../views/Rented.vue'),
  // },
  // {
  //   path: '/property-care',
  //   name: 'Property Care',
  //   component: () => import('../views/PropertyCare.vue'),
  // },
  // {
  //   path: '/contact-us',
  //   name: 'Contact Us',
  //   component: () => import('../views/ContactUs.vue'),
  // },
  // {
  //   path: '/testimonials',
  //   name: 'Testimonials',
  //   component: () => import('../views/Testimonials.vue'),
  // },
  {
    path: '/latest-news',
    name: 'Latest News',
    component: () => import('../views/Blog.vue'),
  },
  // {
  //   path: '/meet-the-team',
  //   name: 'Meet the Team',
  //   component: () => import('../views/MeetTheTeam.vue'),
  // },
  // {
  //   path: '/calculators',
  //   name: 'Calculators',
  //   component: () => import('../views/Calculators.vue'),
  // },
  // {
  //   path: '/inspection-times',
  //   name: 'Inspection Times',
  //   component: () => import('../views/InspectionTimes.vue'),
  // },
  // {
  //   path: '/market-updates',
  //   name: 'Market Updates',
  //   component: () => import('../views/MarketUpdates.vue'),
  // },
  // {
  //   path: '/properties/last-30-rented',
  //   name: 'Last 30 Properties Rented',
  //   component: () => import('../views/Rented.vue'),
  // },
  // {
  //   path: '/forms/notice-of-intention-to-leave',
  //   name: 'Notice of Intention to Leave',
  //   component: () => import('../views/Form13.vue'),
  // },
  // {
  //   path: '/tv-display/sales',
  //   name: 'TV Display Sales',
  //   component: () => import('../views/TVDisplaySales.vue'),
  //   meta: {
  //     hide: true,
  //     hideAncillaries: true, // Disables the header and footer
  //   },
  // },
  // {
  //   path: '/tv-display/rentals',
  //   name: 'TV Display Rentals',
  //   component: () => import('../views/TVDisplayRentals.vue'),
  //   meta: {
  //     hide: true,
  //     hideAncillaries: true, // Disables the header and footer
  //   },
  // },
  // {
  //   path: '/listings/:id',
  //   name: 'Listing',
  //   meta: {
  //     hide: true,
  //   },
  //   component: () => import('../views/ListingDetails.vue'),
  // },
  // {
  //   path: '/listings/:id/make-an-offer',
  //   name: 'Make an Offer',
  //   meta: {
  //     hide: true,
  //   },
  //   component: () => import('../views/ListingMakeAnOffer.vue'),
  // },
  // {
  //   path: '/profiles/:id',
  //   name: 'Profile',
  //   meta: {
  //     hide: true,
  //   },
  //   component: () => import('../views/AgentProfile.vue'),
  // },
  // {
  //   path: '/profiles/:id/properties',
  //   name: 'Profile Listings',
  //   meta: {
  //     hide: true,
  //   },
  //   component: () => import('../views/AgentProfileListings.vue'),
  // },
  // {
  //   path: '/profiles/:id/properties/sold',
  //   name: 'Profile Sold Listings',
  //   meta: {
  //     hide: true,
  //   },
  //   component: () => import('../views/AgentProfileListingsSold.vue'),
  // },
  // {
  //   path: '/profiles/:id',
  //   name: 'Profile',
  //   meta: {
  //     hide: true,
  //   },
  //   component: () => import('../views/AgentProfile.vue'),
  // },
  {
    path: '/blogs/:id',
    name: 'Blog',
    meta: {
      hide: true,
    },
    component: () => import('../views/BlogDetails.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: () => import('../views/Sitemap.vue'),
  },
  // {
  //   path: '/unsubscribe',
  //   name: 'Unsubscribe',
  //   component: () => import('../views/Unsubscribe.vue'),
  // },
  {
    path: '/*',
    name: 'Not Found',
    meta: {
      hide: true,
    },
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
});

export default router;
